module.exports = __webpack_public_path__ + "static/img/1.3b987de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/1.png
// module id = ExXK
// module chunks = 0